import { fmtMontoContable, formatearFechaLarga } from './estadosFinancierosShared';

const C = {
  navy: '#0E1F33',
  navySoft: '#16314F',
  surface: '#F4F6FB',
  surfaceAlt: '#EEF2F8',
  border: '#E6EAF1',
  borderStrong: '#D7DEE9',
  text: '#0F172A',
  textSecondary: '#5A6B85',
  muted: '#94A3B8',
  danger: '#E11D48',
  dangerSoft: '#FFE4E6',
  successDark: '#047857',
  successSoft: '#DCFCE7',
};

const escapeHtml = (str) => {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const esMonto = (col) => col.tipo === 'monto';
const esCuenta = (col) => col.tipo === 'cuenta';
const valorCelda = (fila, col) =>
  fila?.celdas && Object.prototype.hasOwnProperty.call(fila.celdas, col.id)
    ? fila.celdas[col.id]
    : fila?.[col.id];

const htmlMonto = (valor, col, extraClass = '') => {
  const n = parseFloat(valor) || 0;
  if (col.vacioSiCero && Math.abs(n) < 0.005) {
    return `<div class="ef-monto ef-muted ${extraClass}">—</div>`;
  }
  const neg = n < 0 ? ' ef-neg' : '';
  return `<div class="ef-monto${neg} ${extraClass}">$${escapeHtml(fmtMontoContable(n))}</div>`;
};

const gridDe = (modelo) =>
  modelo?.layout?.grid?.print ||
  modelo?.layout?.grid?.md ||
  modelo?.layout?.grid?.xs ||
  '118px 1fr auto';

export const ESTADO_FINANCIERO_PRINT_STYLES = `
  @page { size: letter portrait; margin: 10mm 12mm 12mm; }
  * { box-sizing: border-box; }
  html, body {
    margin: 0;
    padding: 0;
    background: #fff;
    color: ${C.text};
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .ef-doc {
    --ef-cols: 118px 1fr auto;
    width: 100%;
    background: ${C.surfaceAlt};
    overflow: hidden;
  }
  .ef-header {
    text-align: center;
    padding: 28px 36px 22px;
    background: linear-gradient(180deg, ${C.navy} 0%, ${C.navySoft} 100%);
    color: #fff;
  }
  .ef-kicker {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.62);
    margin-bottom: 8px;
  }
  .ef-empresa {
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 0.04em;
    line-height: 1.25;
  }
  .ef-rule {
    width: 56px;
    height: 2px;
    background: rgba(255,255,255,0.35);
    margin: 12px auto;
  }
  .ef-titulo {
    font-weight: 700;
    font-size: 13.5px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }
  .ef-periodo {
    margin-top: 8px;
    font-size: 11.5px;
    font-weight: 500;
    color: rgba(255,255,255,0.82);
  }
  .ef-moneda {
    margin-top: 6px;
    font-size: 9px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.5);
  }
  .ef-body { padding: 22px 32px 28px; }
  .ef-grid {
    display: grid;
    grid-template-columns: var(--ef-cols);
    column-gap: 14px;
    align-items: baseline;
  }
  .ef-cols {
    margin-bottom: 14px;
    padding: 0 6px;
  }
  .ef-colh {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${C.muted};
  }
  .ef-colh.right { text-align: right; }
  .ef-sec { margin-bottom: 18px; page-break-inside: auto; }
  .ef-sec-head {
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 2px solid ${C.navy};
  }
  .ef-sec-title {
    font-weight: 800;
    font-size: 10px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: ${C.navy};
  }
  .ef-sec-sub {
    margin-top: 2px;
    font-size: 9.5px;
    color: ${C.textSecondary};
  }
  .ef-row {
    padding: 6px 6px;
    border-bottom: 1px solid ${C.border};
    page-break-inside: avoid;
  }
  .ef-row.alt { background: ${C.surface}; }
  .ef-cuenta {
    font-size: 10.5px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    color: ${C.muted};
    letter-spacing: 0.02em;
  }
  .ef-nombre {
    font-size: 11.5px;
    font-weight: 500;
    color: ${C.text};
    line-height: 1.35;
    min-width: 0;
  }
  .ef-monto {
    font-variant-numeric: tabular-nums;
    font-size: 11.5px;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    letter-spacing: 0.01em;
    color: ${C.text};
  }
  .ef-monto.ef-neg { color: ${C.danger}; }
  .ef-muted { color: ${C.muted} !important; font-weight: 500; }
  .ef-empty {
    padding: 10px 6px;
    font-size: 11px;
    color: ${C.muted};
    font-style: italic;
  }
  .ef-total {
    padding: 8px 6px;
    border-top: 1px solid ${C.navy};
    page-break-inside: avoid;
  }
  .ef-total .ef-nombre {
    font-weight: 800;
    font-size: 10.5px;
    color: ${C.navy};
  }
  .ef-total .ef-monto {
    font-weight: 800;
    font-size: 12px;
    color: ${C.navy};
  }
  .ef-intermedio {
    margin: 2px 0 18px;
    padding: 9px 6px;
    background: ${C.surfaceAlt};
    border-top: 1px solid ${C.borderStrong};
    border-bottom: 2px solid ${C.navy};
    page-break-inside: avoid;
  }
  .ef-intermedio .ef-nombre {
    font-weight: 800;
    font-size: 10.5px;
    color: ${C.navy};
  }
  .ef-intermedio .ef-monto {
    font-weight: 800;
    font-size: 12px;
    color: ${C.navy};
  }
  .ef-neto {
    margin-top: 6px;
    padding: 12px 14px;
    border-radius: 8px;
    page-break-inside: avoid;
  }
  .ef-neto.ok { background: ${C.successSoft}; }
  .ef-neto.alerta { background: ${C.dangerSoft}; }
  .ef-neto .ef-nombre {
    font-weight: 800;
    font-size: 10.5px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .ef-neto.ok .ef-nombre, .ef-neto.ok .ef-monto { color: ${C.successDark}; }
  .ef-neto.alerta .ef-nombre, .ef-neto.alerta .ef-monto { color: ${C.danger}; }
  .ef-neto .ef-monto {
    font-weight: 800;
    font-size: 14px;
    border-bottom: 3px double currentColor;
    padding-bottom: 1px;
    display: inline-block;
    justify-self: end;
  }
  .ef-nota {
    margin-top: 22px;
    font-size: 9px;
    color: ${C.muted};
    text-align: center;
    letter-spacing: 0.02em;
  }
  .ef-print-meta {
    margin-top: 18px;
    font-size: 8.5px;
    color: ${C.muted};
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  .ef-firmas {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    margin-top: 42px;
    padding: 0 12px;
    page-break-inside: avoid;
  }
  .ef-firma { text-align: center; }
  .ef-firma-linea {
    border-top: 1px solid ${C.navy};
    margin-bottom: 6px;
  }
  .ef-firma-label {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${C.textSecondary};
  }
`;

const htmlCeldasFila = (columnas, fila) =>
  columnas
    .map((col) => {
      if (esCuenta(col)) {
        return `<div class="ef-cuenta">${escapeHtml(fila.cuenta || '—')}</div>`;
      }
      if (!esMonto(col)) {
        return `<div class="ef-nombre">${escapeHtml(fila.nombre || '—')}</div>`;
      }
      return htmlMonto(valorCelda(fila, col), col);
    })
    .join('');

const htmlCeldasTotal = (columnas, total, claseMonto = '') =>
  columnas
    .map((col) => {
      if (esCuenta(col)) return '<div></div>';
      if (!esMonto(col)) {
        return `<div class="ef-nombre">${escapeHtml(total.etiqueta || '')}</div>`;
      }
      return htmlMonto(valorCelda(total, col), { ...col, vacioSiCero: false }, claseMonto);
    })
    .join('');

const htmlFilaTotal = (columnas, total) => {
  const variante = total.variante || 'seccion';
  if (variante === 'neto') {
    const tono = total.tono === 'alerta' ? 'alerta' : 'ok';
    return `<div class="ef-grid ef-neto ${tono}">${htmlCeldasTotal(columnas, total)}</div>`;
  }
  if (variante === 'intermedio') {
    return `<div class="ef-grid ef-intermedio">${htmlCeldasTotal(columnas, total)}</div>`;
  }
  return `<div class="ef-grid ef-total">${htmlCeldasTotal(columnas, total)}</div>`;
};

const htmlSeccion = (columnas, seccion, mensajeVacioDef) => {
  const filas = seccion.filas || seccion.cuentas || [];
  const cuerpo =
    filas.length === 0
      ? `<div class="ef-empty">${escapeHtml(seccion.mensajeVacio || mensajeVacioDef)}</div>`
      : filas
          .map(
            (fila, i) =>
              `<div class="ef-grid ef-row${i % 2 ? ' alt' : ''}">${htmlCeldasFila(columnas, fila)}</div>`
          )
          .join('');

  const despues = (seccion.despues || []).map((t) => htmlFilaTotal(columnas, t)).join('');
  const total = seccion.total ? htmlFilaTotal(columnas, seccion.total) : '';
  const sub = seccion.subtitulo
    ? `<div class="ef-sec-sub">${escapeHtml(seccion.subtitulo)}</div>`
    : '';

  return (
    `<section class="ef-sec">` +
    `<div class="ef-sec-head"><div class="ef-sec-title">${escapeHtml(seccion.titulo || '')}</div>${sub}</div>` +
    `${cuerpo}${total}${despues}` +
    `</section>`
  );
};

/**
 * Genera HTML de impresión alineado a la presentación en pantalla.
 * @param {object} modelo mismo contrato que PlantillaEstadoFinanciero
 */
export const buildPlantillaEstadoFinancieroPrint = (modelo = {}) => {
  const columnas = modelo.columnas || [];
  const secciones = modelo.secciones || [];
  const totales = modelo.totales || [];
  const grid = gridDe(modelo);
  const mensajeVacio = modelo.mensajeVacio || 'Sin movimientos en esta sección';
  const kicker = modelo.kicker || 'Estados financieros';
  const monedaNota = modelo.monedaNota || 'Cifras expresadas en moneda de la empresa';
  const firmas = Array.isArray(modelo.firmas) ? modelo.firmas : [];

  const colsHead = columnas
    .map(
      (col) =>
        `<div class="ef-colh${esMonto(col) ? ' right' : ''}">${escapeHtml(col.label || '')}</div>`
    )
    .join('');

  const firmasHtml =
    firmas.length > 0
      ? `<div class="ef-firmas">${firmas
          .map(
            (f) =>
              `<div class="ef-firma"><div class="ef-firma-linea"></div>` +
              `<div class="ef-firma-label">${escapeHtml(f.etiqueta || '')}</div></div>`
          )
          .join('')}</div>`
      : '';

  const generacion = formatearFechaLarga(
    `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(
      new Date().getDate()
    ).padStart(2, '0')}`
  );

  const bodyHtml =
    `<div class="ef-doc" style="--ef-cols: ${grid}">` +
    `<header class="ef-header">` +
    `<div class="ef-kicker">${escapeHtml(kicker)}</div>` +
    `<div class="ef-empresa">${escapeHtml(modelo.nombreEmpresa || 'Empresa')}</div>` +
    `<div class="ef-rule"></div>` +
    `<div class="ef-titulo">${escapeHtml(modelo.tituloDocumento || '')}</div>` +
    `<div class="ef-periodo">${escapeHtml(modelo.periodo || '')}</div>` +
    `<div class="ef-moneda">${escapeHtml(monedaNota)}</div>` +
    `</header>` +
    `<div class="ef-body">` +
    `<div class="ef-grid ef-cols">${colsHead}</div>` +
    secciones.map((s) => htmlSeccion(columnas, s, mensajeVacio)).join('') +
    (totales.length
      ? `<div style="margin-top:10px">${totales.map((t) => htmlFilaTotal(columnas, t)).join('')}</div>`
      : '') +
    (modelo.nota ? `<div class="ef-nota">${escapeHtml(modelo.nota)}</div>` : '') +
    firmasHtml +
    `<div class="ef-print-meta">Documento generado el ${escapeHtml(generacion)}</div>` +
    `</div></div>`;

  return {
    bodyHtml,
    extraStyles: ESTADO_FINANCIERO_PRINT_STYLES,
    skipHeader: true,
  };
};

export default buildPlantillaEstadoFinancieroPrint;
